import { avecAlpha } from '../../../lib/couleurs'

// Dossier exposant — AFFICHAGE seulement (prototype v7.5, constantes DOSSIER_*).
// Les REGLES (pieces demandees, complet ou non) vivent cote serveur
// (`dossier-exposant.rules.ts`) : le portail lit l'etat que l'API renvoie.

export const ORANGE = 'rgb(var(--c-primary))'
export const TEAL = 'rgb(var(--c-teal))'
export const VERT = 'rgb(var(--c-green))'
export const CREME = 'rgb(var(--c-creme))'
// Tons d'etat du prototype (hors charte, comme VERT_OK du module Marche)
export const BRUN = '#b4551f'
export const VERT_OK = '#0a8a5f'
export const ROUGE = '#d9534f'
export const ROUGE_TEXTE = '#a93a36'

export const STATUTS = [
  { k: 'pro', e: '🧾', l: 'Entreprise ou exploitation déclarée', s: 'Micro-entreprise, société, exploitant agricole…' },
  { k: 'asso', e: '🤝', l: 'Association', s: 'Loi 1901, déclarée en préfecture' },
  { k: 'encours', e: '⏳', l: 'Déclaration en cours', s: 'Démarche lancée, numéro pas encore reçu' },
]

export const ACTIVITES = [
  { k: 'AGRICOLE', e: '🌾', l: 'Production agricole', s: 'Fruits, légumes, racines, plantes — produits bruts' },
  { k: 'TRANSFO', e: '🫙', l: 'Transformation alimentaire', s: 'Jus, confitures, sirops, épices…' },
  { k: 'RESTAURATION', e: '🍲', l: 'Restauration sur place', s: 'Plats, snacks, boissons servis au stand' },
  { k: 'ARTISANAT', e: '🧺', l: 'Artisanat non alimentaire', s: 'Vannerie, bijoux, textile, décoration…' },
  { k: 'BIEN_ETRE', e: '🌿', l: 'Bien-être & cosmétique', s: 'Savons, huiles, soins…' },
  { k: 'SERVICES', e: '🎨', l: 'Services & animation', s: 'Ateliers, démonstrations, animations' },
]

/** Pastille d'etat d'une piece — statuts renvoyes par l'API. */
export const STATUT_PIECE = {
  MANQUANTE: { l: 'À fournir', c: BRUN, e: '＋' },
  EN_COURS: { l: 'En vérification', c: ORANGE, e: '⏳' },
  VALIDEE: { l: 'Validée', c: VERT_OK, e: '✓' },
  REFUSEE: { l: 'À refaire', c: ROUGE, e: '↺' },
  EXPIREE: { l: 'Expirée', c: ROUGE, e: '↺' },
}

export const teinte = (c, a) => avecAlpha(c, a)

/** AAAA-MM-JJ -> JJ/MM/AAAA */
export const dateFr = (iso) => (iso ? String(iso).slice(0, 10).split('-').reverse().join('/') : '')

/** Meme test que le serveur, pour le message sous le champ (affichage seulement). */
export const siretBienForme = (s) => /^\d{9}(\d{5})?$/.test((s || '').replace(/\s/g, ''))

export const pluriel = (n, mot) => `${n} ${mot}${n > 1 ? 's' : ''}`

/** Texte du rappel « à compléter » (bulle RINA, compte, stand). */
export const texteRappel = (etat) =>
  `${pluriel(etat.manquants.length, 'élément')} à fournir — exigé par la mairie pour le marché.`
